import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { profileSelector } from "../../utils/selectors";
// import styles from "./Patterns.module.scss";
import ProductContent from "./PatternContent";
import ProductHeader from "./PatternsHeader";
import { getProfileByHandle } from "../../actions/profileActions";

const Patterns = ({ profile: { profile, loading }, getProfileByHandle }: any) => {
  const { handle } = useParams();

  useEffect(() => {
    if (handle) {
      getProfileByHandle(handle);
    }
  }, [handle, getProfileByHandle]);

  const productContent =
    profile &&
    profile !== null &&
    profile.patterns &&
    Array.isArray(profile.patterns) &&
    profile.patterns.map((prod: any) => (
      <ProductContent key={prod} product={prod} />
    ));

  return (
    <div className="profile">
      <div className="container">
        <ProductHeader />
        <div className="row">{productContent}</div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  profile: profileSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  getProfileByHandle: (handle: string) => dispatch(getProfileByHandle(handle)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Patterns);
